/**
 * Define goods sales mixin
 *
 * @author minkyoung.park@emcast.com
 */
export const salesMixin = {
    
    methods: {
        // 학습하기로 이동(move learn)
        moveLearn() {
            if (this.category.key === 'ONLINE') {
                this.$router.push({
                    name: 'Learn',
                    query: {status: 'LEARNING'}
                })
            }else {
                this.$router.push({
                    name: 'IndependentExam',
                    query: {listType: 'my'}
                })
            }
        },

        // 전체학습으로 이동(move degree)
        moveTotalDegree() {
            this.$router.push({
                name: 'Degree',
                query: {type: 'ListTotal'}
            })

        },

        // 목록으로 이동(move degree/independent exam)
        moveList() {
            if (this.category.key === 'ONLINE') {
                this.$router.push({
                    name: 'Degree',
                    query: {type: 'ListTotal'}
                })
            }else {
                this.$router.push({
                    name: 'IndependentExam',
                    query: {listType: 'total'}
                })
            }
            

        },

        // 구매목록으로 이동(move purchase history)
        movePurchaseList() {
            this.$router.push({
                name: 'MemberPurchase'
            })
        },

        // 수강신청 완료 화면 이동(move sales result)
        movePaymentResult() {
            this.$router.push({
                name: 'SalesResultEnroll', 
                params: {orderId: this.orderId}, 
                query: this.$route.query
            })
        },

        // 무료여부 체크(check free)
        isFree() {
            return this.paymentPrice > 0 ? false : true
        },

        // 결제화면으로 이동(move payment)
        next() {
            this.$validator.validateAll().then((resultValid) => {
                console.log('resultValid', resultValid);
                
                this.submitState = true
                if (resultValid) {
                    this.SET_ORDERERENAME(this.orderMemberName)
                    this.SET_ORDEREREMAIL(this.ordererEmail)
                    this.SET_ORDEREREPHONE(this.ordererPhone)
                    this.$router.push({
                        name: 'SalesCart', 
                        params: {orderId: this.orderId}, 
                        query: this.$route.query
                    })
                }
            })
            
        }


    }
}